import { Client } from '@microsoft/microsoft-graph-client';
import type { IGraphClient } from '../../src/services/GraphService';
import { getToken } from './auth';

/** A Graph client that authenticates with the given delegated scopes. */
export function createGraphClient(scopes: string[]): IGraphClient {
  return Client.init({
    authProvider: done => {
      getToken(scopes).then(token => done(null, token)).catch(error => done(error, null));
    }
  });
}
